import React from "react";
import { Navigate } from "react-router-dom";
import { MainLayoutUrl } from "../../router/router_path";
export default function RoleDetailScreen() { return <Navigate to={MainLayoutUrl.systemconfig.roles.index.path} replace />; }
